import { useSelector } from 'react-redux';

const GlobalModal = () => {
  const { showGlobalModal, contentGlobalModal } = useSelector(
    (state: any) => state.app
  );

  return showGlobalModal ? contentGlobalModal : null;
};

export default GlobalModal;
